import moment from 'moment';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';

function criticalPathDatesTemplate(activity, property, columnName, gantt) {
  const hasChild = gantt.hasChild(activity.id);
  const date = moment(activity[property]);
  const dateString = date.format(gantt.currentDateFormat).toString();
  if (gantt.isSummaryTask(activity)) {
    return '';
  }
  let isOdd = false;
  if (gantt.oddColsConfig) {
    isOdd = gantt.oddColsConfig[columnName];
  }

  const htmlH = getStringHidden(dateString, columnName);

  return `
    <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; color: #121212;">
      <span class="string-v">${date.format(gantt?.currentDateFormat?.replace('hh', 'HH'))}</span>
      ${htmlH}
    </div>`;
}

export const getCriticalPathColumns = (gantt) => {
  return [
    {
      name: 'early_start',
      label: 'Early Start',
      align: 'center',
      resize: true,
      width: '75',
      template: function (activity) {
        return criticalPathDatesTemplate(
          activity,
          'earlyStart',
          'early_start',
          gantt
        );
      },
      hide: !isColumnVisibleByDefault('early_start'),
      data_type: 'date',
      groupable: false,
      orderable: true,
      orderable_switch: ['1 → N', 'N → 1'],
      filterable: true
    },
    {
      name: 'early_finish',
      label: 'Early Finish',
      align: 'center',
      resize: true,
      width: '75',
      template: function (activity) {
        return criticalPathDatesTemplate(
          activity,
          'earlyFinish',
          'early_finish',
          gantt
        );
      },
      hide: !isColumnVisibleByDefault('early_finish'),
      data_type: 'date',
      groupable: false,
      orderable: true,
      orderable_switch: ['1 → N', 'N → 1'],
      filterable: true
    },
    {
      name: 'late_start',
      label: 'Late Start',
      align: 'center',
      resize: true,
      width: '75',
      template: function (activity) {
        return criticalPathDatesTemplate(
          activity,
          'lateStart',
          'late_start',
          gantt
        );
      },
      hide: !isColumnVisibleByDefault('late_start'),
      data_type: 'date',
      groupable: false,
      orderable: true,
      orderable_switch: ['1 → N', 'N → 1'],
      filterable: true
    },
    {
      name: 'late_finish',
      label: 'Late Finish',
      align: 'center',
      resize: true,
      width: '75',
      template: function (activity) {
        return criticalPathDatesTemplate(
          activity,
          'lateFinish',
          'late_finish',
          gantt
        );
      },
      hide: !isColumnVisibleByDefault('late_finish'),
      data_type: 'date',
      groupable: false,
      orderable: true,
      orderable_switch: ['1 → N', 'N → 1'],
      filterable: true
    }
  ];
}; 